<template>
  <div id="bakgrund" >
    <h1>Monty Hall-problemet </h1>

<div id="luckrad">

<div class="luckplats">

<img src="../assets/sportbil.jpg" class="bilder" id="bil1">
<img src="../assets/get.jpg" class="bilder2" id="get1">
<div id="lucka1" class="luckor" @click="addLift(1)">
  <div class="lucknummer">1</div>
</div>

</div>

<div class="luckplats">
  <img src="../assets/sportbil.jpg" class="bilder" id="bil2">
  <img src="../assets/get.jpg" class="bilder2" id="get2">
<div id="lucka2" class="luckor"  @click="addLift(2)">
  <div class="lucknummer">2</div>
</div>
</div>

<div class="luckplats">
  <img src="../assets/sportbil.jpg" class="bilder" id="bil3">
  <img src="../assets/get.jpg" class="bilder2" id="get3">
<div id="lucka3" class="luckor" @click="addLift(3)">
  <div class="lucknummer">3</div>
</div>
</div>

</div>



</div>
</template>

<script>
export default {
    name: 'MontyHall',
    props: {
        msg: String
    },
    methods: {
        addLift: function(luckNr){
            var lucka = document.getElementById("lucka" + luckNr);
            lucka.classList.add("upplyft");
        },

       fixaVinstlucka: function(nummer){
        if(nummer == 49) {
          document.getElementById("bil1").style.display="inline";
          document.getElementById("get1").style.display="none";

          document.getElementById("bil2").style.display="none";
          //document.getElementById("get2").style.display="inline";

          document.getElementById("bil3").style.display="none";
          //document.getElementById("get3").style.display="inline";
        }
        if(nummer == 50) {
          document.getElementById("bil1").style.display="none";
          //document.getElementById("get1").style.display="inline";

          document.getElementById("bil2").style.display="inline";
          document.getElementById("get2").style.display="none";

          document.getElementById("bil3").style.display="none";
          //document.getElementById("get3").style.display="inline";
        }

        if(nummer == 51) {
          document.getElementById("bil1").style.display="none";
          //document.getElementById("get1").style.display="inline";

          document.getElementById("bil2").style.display="none";
          //document.getElementById("get2").style.display="inline";

          document.getElementById("bil3").style.display="inline";
          document.getElementById("get3").style.display="none";
        }

      }
    },

    created() {
        document.title = 'Monty Hall-problemet';
        const favicon = document.getElementById('favicon');
        favicon.href="../src/assets/bil.ico";
        //favicon.href="https://www.google.com/favicon.ico";

    },
    mounted() {
      var that=this;
      document.addEventListener("keydown", function(event) {
      that.fixaVinstlucka(event.keyCode);
      })

    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  padding-top:20px;
  font-size: 3em;
  color:orange;
}


#bakgrund {
  margin-top:-32px;
  background-color:black;
  width:100%;
  height:100vh;
}

#luckrad {
  margin-top:200px;
  width:100%;
  height: 200px;


}
.bilder {
  position: absolute;
  width:175px;

  margin-left:-90px;
  margin-top:100px;
}

.bilder2 {
  position: absolute;


  margin-left:-80px;
  margin-top:0px;
}


.luckplats {


  width: 200px;
  height:200px;
  display: inline-block;
  margin-left:50px;
  margin-right:50px;
  background-color: white;
}

#lucka1{
  position:absolute;
  background-color: green;
}
#lucka1:hover {
  box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  border: solid 1px;
  border-color: white;
}

#lucka2{
  position:absolute;
  background-color: blue;
}

#lucka2:hover {
  box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  border: solid 1px;
  border-color: white;
}


#lucka3{
  position:absolute;
  background-color: red;
}

#lucka3:hover {
  box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  border: solid 1px;
  border-color: white;
}

#bil1, #bil2, #bil3, #get1, #get2, #get3 {
  display: none;
}
.luckor {
  height: 200px;
  width: 200px;
}

.lucknummer {

    font-size: 7em;
    width: 135px;
    border-radius: 100px;
    background-color: white;
    margin: auto;
    margin-top: 30px;
}

.lucknummer:hover {
  background-color: lightgrey;
}

.upplyft {
  margin-top: -200px;

  transition: 1s;
}


</style>
